import { Component, OnInit } from '@angular/core';
import { GenericService } from '../services/generic.service';
import {ActivatedRoute } from '@angular/router';
import { SplashScreenStateService } from '../services/splash-screen-state-service';
// import { SpinnerComponent } from '../spinner/spinner.component';

@Component({
  selector: 'app-generic',
  templateUrl: './generic.component.html',
  styleUrls: ['./generic.component.css']
})
export class GenericComponent implements OnInit {
  public theHtmlString ="";
  retItem: any;
  retItems: any;
  linkUrl = "";
  id:any;
//  public spinner: any = SpinnerComponent;
  constructor(private genericService: GenericService, private route: ActivatedRoute,private splashScreenStateService: SplashScreenStateService) { 

  }

  // ngOnInit(): void {
  //   setTimeout(() => {
  //      this.splashScreenStateService.stop();
       
  //   }, 5000);
   
  // }



  ngOnInit() {
    setTimeout(() => {
      this.splashScreenStateService.stop();
      
   }, 100);

    this.route.params.subscribe( params => {console.log(params);
      this.LoadData(params.id);
      var p = 'link-' + params.id;
      console.log(p);
      this.id = params.id;
      this.LoadItems(6, p);

      
      var page = this.route.snapshot.routeConfig.path;
      var test = page.substr(0,7);
      if (test == 'lighter'){
        if(this.id == "349"){
          this.linkUrl = "videos";
        }
        else{
          this.linkUrl = "photos";
        }
   
      }
      else{
        this.linkUrl = "item-detail";
      }


    });


  }

  LoadItems(siteId:number, mainDet:string) {
    
    this.genericService.getItems(siteId, mainDet).subscribe((data) => {
      this.retItems = data;
    //  alert('component LoadItems done');
    //  this.splashScreenStateService.stop();

      this.splashScreenStateService.stop();
  //   this.spinner.hideSpinnerAnimation();
      // console.log(this.retItem);
    }),
    err => {
       console.log(err);
    }
}
  LoadData(id:any ) {
    
    this.genericService.getItem(id).subscribe((data) => {
      this.retItem = data;
     // alert('component LoadData done');
        this.theHtmlString = this.retItem.html_content;
    }), 
    err => {
         console.log(err);
      }
  }
}

